import { isDemoMode } from 'config/demo-mode';
import type { AuthUser, LoginRequest } from 'features/auth';
import { demoAuthUser, demoCredentials } from './mock-data';
import { removeDemoStorage, writeDemoStorage } from './storage';

export const DEMO_SESSION_KEY = 'mineacs_demo_session';

interface DemoSession {
  user: AuthUser;
  authenticatedAt: string;
}

export function getDemoSession(): AuthUser | null {
  if (!isDemoMode || typeof window === 'undefined') return null;

  const raw = window.localStorage.getItem(DEMO_SESSION_KEY);
  if (!raw) return null;

  try {
    const session = JSON.parse(raw) as DemoSession;
    return session.user?.email === demoCredentials.email ? session.user : null;
  } catch {
    removeDemoStorage(DEMO_SESSION_KEY);
    return null;
  }
}

export async function loginDemo(request: LoginRequest): Promise<AuthUser> {
  if (request.email.trim().toLowerCase() !== demoCredentials.email || request.password !== demoCredentials.password) {
    throw new Error('Credential demo tidak valid');
  }

  const session: DemoSession = {
    user: demoAuthUser,
    authenticatedAt: new Date().toISOString()
  };

  writeDemoStorage(DEMO_SESSION_KEY, session);
  return session.user;
}

export async function logoutDemo(): Promise<void> {
  removeDemoStorage(DEMO_SESSION_KEY);
}
